import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable } from 'rxjs';

import { environment } from '../../../environments/environment';
import { NotificationsService } from '../services/notification.service';
import { eLocalStorageItems } from '../models';

@Injectable()
export class Interceptor implements HttpInterceptor {
    public deployment = environment.deployment;

    constructor(
        private router: Router,
        private modalService: NgbModal,
        private notificationsService: NotificationsService
    ) { }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(req).catch((error, caught) => {
            console.log(error);
            if (error.status === 401) {
                this.modalService.dismissAll('');
                this.router.navigate(['/login']);
                localStorage.setItem(this.deployment + eLocalStorageItems.redirectionError, error.error.message);
            }
            if (error.status === 403) {
                this.router.navigate(['/map']);
                localStorage.setItem(this.deployment + eLocalStorageItems.redirectionError, error.error.message);
            }

            const title = 'Error';
            let err = null;
            console.log(error);
            if (error.error && error.error.error_description) {
                err = error.error.error_description;
            } else if (error.error.message) {
                err = error.error.message;
            } else if (error.error.Message) {
                err = error.error.Message;
            } else if (!(error.error instanceof ArrayBuffer)) {
                err = error.error;
            } else if (error.error instanceof ArrayBuffer) {
                const enc = new TextDecoder('utf-8');
                const arr = new Uint8Array(error.error);
                console.log(enc.decode(arr));
                const errorObject: any = JSON.parse(enc.decode(arr));
                err = errorObject.message;
            } else {
                err = error;
            }

            if (error.status === 0) {
                console.log(error);
                err = 'The aplication is offline';
            }

            if (error.status === 401 || error.status === 0) {
                console.log(error);
                if (error.status === 0) {
                    this.notificationsService.notify('error', title, err);
                }
            }

            if (!err) {
                err = 'Server error';
            }
            return Observable.throwError(err);
        }) as any;
    }
}
